import * as React from "react";
import {
  IPeerGroupTabsProps,
  IVisualizationState,
  IFilter,
} from "../../lib/http";
import * as ReactHighcharts from "react-highcharts";
import { Panel } from 'react-bootstrap'
//import PanelGraph from "app/components/tabs/PanelGraph";
const HighchartsMore = require("highcharts/highcharts-more");
HighchartsMore(ReactHighcharts.Highcharts);

export class Visualization13 extends React.Component<
  IPeerGroupTabsProps,
  IVisualizationState
  > {
  state: IVisualizationState = {
    categories: [],
    data: [],
    series: [],
    filters: { assetLevel: -1 },
    title: "",
    loading: false,
    average: [],
  };

  componentDidMount() {
    this.setState({ data: this.props.data }, () =>
      this.loadSeries(this.props.filters)
    );
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.filters.assetLevel !== this.props.filters.assetLevel ||
      prevProps.data.length !== this.props.data.length
    ) {
      this.setState(
        { filters: this.props.filters, data: this.props.data },
        () => {
          this.loadSeries(this.props.filters);
        }
      );
    }
  }

  loadSeries(filters: IFilter) {
    const { data } = this.state;
    const categories = [
      "",
      "Trustee & Officer Compensation",
      "Salaries, Wages, & Benefits",
      "Legal and Accounting",
      "Professional Fees",
      "Taxes",
      "Occupancy",
      "Other",
    ];

    const currentSet = data.find(
      (dataPoint) => dataPoint.filterId === filters.assetLevel
    );

    if (currentSet) {
      const title = currentSet["OpEx_T_V13_Vis13Title"];

      const seriesData = [
        [currentSet["OpEx_N_V13_LoRange"], currentSet["OpEx_N_V13_HiRange"]],
        [currentSet["OpEx_N_V13_LoTrust"], currentSet["OpEx_N_V13_HiTrust"]],
        [currentSet["OpEx_N_V13_LoWages"], currentSet["OpEx_N_V13_HiWages"]],
        [currentSet["OpEx_N_V13_LoLglAcc"], currentSet["OpEx_N_V13_HiLglAcc"]],
        [
          currentSet["OpEx_N_V13_LoProfees"],
          currentSet["OpEx_N_V13_HiProfees"],
        ],
        [currentSet["OpEx_N_V13_LoTaxes"], currentSet["OpEx_N_V13_HiTaxes"]],
        [currentSet["OpEx_N_V13_LoOcc"], currentSet["OpEx_N_V13_HiOcc"]],
        [currentSet["OpEx_N_V13_LoOther"], currentSet["OpEx_N_V13_HiOther"]],
      ];

      const average = [
        {
          y: currentSet["OpEx_N_V13_MdnRange"],
          name: currentSet["OpEx_T_V13_Vis13LabelMdn"],
        },
        {
          y: currentSet["OpEx_N_V13_MdnTrust"],
          name: currentSet["OpEx_T_V13_Vis13LabelMdnTrust"],
        },
        {
          y: currentSet["OpEx_N_V13_MdnWages"],
          name: currentSet["OpEx_T_V13_Vis13LabelMdnWages"],
        },
        {
          y: currentSet["OpEx_N_V13_MdnLglAcc"],
          name: currentSet["OpEx_T_V13_Vis13LabelMdnLglAcc"],
        },
        {
          y: currentSet["OpEx_N_V13_MdnProfees"],
          name: currentSet["OpEx_T_V13_Vis13LabelMdnProfees"],
        },
        {
          y: currentSet["OpEx_N_V13_MdnTaxes"],
          name: currentSet["OpEx_T_V13_Vis13LabelMdnTaxes"],
        },
        {
          y: currentSet["OpEx_N_V13_MdnOcc"],
          name: currentSet["OpEx_T_V13_Vis13LabelMdnOcc"],
        },
        {
          y: currentSet["OpEx_N_V13_MdnOther"],
          name: currentSet["OpEx_T_V13_Vis13LabelMdnOther"],
        },
      ];

      const low = [
        {
          y: currentSet["OpEx_N_V13_LoRange"],
          name: currentSet["OpEx_T_V13_Vis13Label25th"],
          marker: { enabled: false },
        },
        {
          y: currentSet["OpEx_N_V13_LoTrust"],
          name: currentSet["OpEx_T_V13_Vis13LabelLoTrust"],
          marker: { enabled: false },
        },
        {
          y: currentSet["OpEx_N_V13_LoWages"],
          name: currentSet["OpEx_T_V13_Vis13LabelLoWages"],
          marker: { enabled: false },
        },
        {
          y: currentSet["OpEx_N_V13_LoLglAcc"],
          name: currentSet["OpEx_T_V13_Vis13LabelLoLglAcc"],
          marker: { enabled: false },
        },
        {
          y: currentSet["OpEx_N_V13_LoProfees"],
          name: currentSet["OpEx_T_V13_Vis13LabelLoProfees"],
          marker: { enabled: false },
        },
        {
          y: currentSet["OpEx_N_V13_LoTaxes"],
          name: currentSet["OpEx_T_V13_Vis13LabelLoTaxes"],
          marker: { enabled: false },
        },
        {
          y: currentSet["OpEx_N_V13_LoOcc"],
          name: currentSet["OpEx_T_V13_Vis13LabelLoOcc"],
          marker: { enabled: false },
        },
        {
          y: currentSet["OpEx_N_V13_LoOther"],
          name: currentSet["OpEx_T_V13_Vis13LabelLoOther"],
          marker: { enabled: false },
        },
      ];

      const high = [
        {
          y: currentSet["OpEx_N_V13_HiRange"],
          name: currentSet["OpEx_T_V13_Vis13Label75th"],
          marker: { enabled: false },
          datalabels: {
            align: "left",
          },
        },
        {
          y: currentSet["OpEx_N_V13_HiTrust"],
          name: currentSet["OpEx_T_V13_Vis13LabelHiTrust"],
          marker: { enabled: false },
          datalabels: {
            align: "left",
          },
        },
        {
          y: currentSet["OpEx_N_V13_HiWages"],
          name: currentSet["OpEx_T_V13_Vis13LabelHiWages"],
          marker: { enabled: false },
          datalabels: {
            align: "left",
          },
        },
        {
          y: currentSet["OpEx_N_V13_HiLglAcc"],
          name: currentSet["OpEx_T_V13_Vis13LabelHiLglAcc"],
          marker: { enabled: false },
          datalabels: {
            align: "left",
          },
        },
        {
          y: currentSet["OpEx_N_V13_HiProfees"],
          name: currentSet["OpEx_T_V13_Vis13LabelHiProfees"],
          marker: { enabled: false },
          datalabels: {
            align: "left",
          },
        },
        {
          y: currentSet["OpEx_N_V13_HiTaxes"],
          name: currentSet["OpEx_T_V13_Vis13LabelHiTaxes"],
          marker: { enabled: false },
          datalabels: {
            align: "left",
          },
        },
        {
          y: currentSet["OpEx_N_V13_HiOcc"],
          name: currentSet["OpEx_T_V13_Vis13LabelHiOcc"],
          marker: { enabled: false },
          datalabels: {
            align: "left",
          },
        },
        {
          y: currentSet["OpEx_N_V13_HiOther"],
          name: currentSet["OpEx_T_V13_Vis13LabelHiOther"],
          marker: { enabled: false },
          datalabels: {
            align: "left",
          },
        },
      ];

      const series = [
        { type: "columnrange", name: "Expenses", data: seriesData },
        {
          type: "line",
          marker: { enabled: true, height: 200 },
          name: "Median",
          data: average,
          dataLabels: "center",
        },
        {
          type: "line",
          name: "Low",
          data: low,
          dataLabels: {
            align: "right",
          },
        },
        {
          type: "line",
          name: "High",
          data: high,
          dataLabels: {
            align: "left",
          },
        },
      ];

      this.setState({ title, series, categories, average });
    }
  }

  static getChartConfig(series, categories) {
    return {
      chart: {
        type: "columnrange",
        inverted: true,
        height: 500,
      },
      title: {
        text: "",
      },
      legend: {
        enabled: false,
      },
      xAxis: {
        categories,
        lineWidth: 0,
        minorTickLenth: 0,
        tickLength: 0,
      },
      yAxis: {
        visible: false,
        type: "logarithmic",
      },
      credits: {
        enabled: false,
      },
      plotOptions: {
        columnrange: {
          dataLabels: {
            enabled: false,
            crop: false,
            overflow: "none",
          },
          pointWidth: 0,
        },
        line: {
          dataLabels: {
            enabled: true,
            format: "{point.name}",
            crop: false,
            overflow: "none",
            align: "right",
            allowOverlap: true,
          },
          lineWidth: 0,
          states: {
            hover: {
              enabled: false,
            },
          },
        },
      },
      series,
    };
  }
  /*
    render() {
      const { title, loading, series, categories } = this.state;
      return (
        <PanelGraph
          title={title}
          loading={loading}
          chartConfig={Visualization13.getChartConfig(series, categories)}
        />
      );
    }
  */

  render() {
    const { title, loading, series, categories } = this.state;
    return (
      <Panel>
        <div className="panel-body text-center">
          {title}{loading && <i className="fa fa-cog fa-spin"></i>}<br />
        </div>
        <div className="panel-body">
          <ReactHighcharts config={Visualization13.getChartConfig(series, categories)} ref="chart" />
        </div>
      </Panel>
    )
  }

}



// WEBPACK FOOTER //
// ./src/app/components/visualizations/PeerGroups/OperatingExpenses/Visualization13/index.tsx